export default __webpack_public_path__ + "static/media/lines.9fc90bd1.svg";